import React, { useState, useEffect } from "react";
import { Outlet, useParams, useNavigate } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";
import { adminAPI } from "../../services/api";
import "./Admin.css";

const AdminLayout = () => {
  const { eventId } = useParams();
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      const res = await adminAPI.getEvents();
      setEvents(res.data);
    } catch (err) {
      console.error("Failed to fetch events for selector", err);
    }
  };

  const handleEventChange = (e) => {
    const newId = e.target.value;
    const currentPath = window.location.pathname;
    
    // Determine the current sub-page (e.g., 'speakers', 'sessions')
    let subPath = "";
    
    if (currentPath.includes("/admin/event/")) {
      // It's a scoped path: /admin/event/:id/subpath
      const parts = currentPath.split("/");
      // parts would be ['', 'admin', 'event', ':id', 'subpath']
      subPath = parts.slice(4).join("/");
    } else if (currentPath.startsWith("/admin/")) {
      // It's a global path: /admin/subpath
      subPath = currentPath.replace("/admin/", "");
    }
    
    // Construct new URL
    if (newId) {
      if (subPath) {
        navigate(`/admin/event/${newId}/${subPath}`);
      } else {
        navigate(`/admin/event/${newId}`);
      }
    } else {
      // Switching to global view
      if (subPath) {
        navigate(`/admin/${subPath}`);
      } else {
        navigate("/admin");
      }
    }
  };

  return (
    <div className="admin-layout">
      <AdminSidebar />
      <main className="admin-main">
        <header className="admin-top-bar">
          <div className="top-bar-left">
            <select
              className="event-scope-selector"
              value={eventId || ""}
              onChange={handleEventChange}
              style={{
                padding: "8px 12px",
                borderRadius: "8px",
                border: "1px solid #e2e8f0",
                fontSize: "0.875rem",
                fontWeight: "500",
                minWidth: "200px",
              }}
            >
              <option value="">Select Event Scope...</option>
              {events.map((event) => (
                <option key={event.id} value={event.id}>
                  {event.title}
                </option>
              ))}
            </select>
          </div>
          <div className="top-bar-right">
            {/* User Profile / Notifications could go here */}
          </div>
        </header>
        <div className="admin-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
